import { createIntl, createIntlCache } from "react-intl"
import { I18n } from "shared/types/config";
import { store } from "store";
import { LocaleMessageFormatElement } from "shared/types/config";

export const loadLocaleData = (i18n: I18n) => {
  switch (i18n) {
    case "en":
      return import("shared/utils/locales/en.json");
    case "kz":
      return import("shared/utils/locales/kz.json");
    default:
      return import("shared/utils/locales/ru.json");
  }
};

const cache = createIntlCache();

export const getIntl = async ()=>{
  const i18n = store.getState().config?.i18n || "ru";
  const loadedLocales = loadLocaleData(i18n).then(
    (d: {
      default:LocaleMessageFormatElement | undefined
    }) => {
      const createdIntl = createIntl({
        locale:i18n,
        messages:d.default,
       }, cache);
      return createdIntl;
    }
); 
return loadedLocales;
}